import React from 'react';
import { LoggedInSubHeader } from './LoggedInSubHeader';
import { StyledHeaderPlacebo, StyledHeaderWrapper, StyledCenterContainer, StyledLogoWrapper, StyledLogo, } from './HeaderLoggedIn.styles';
const Logo = ({ homeLink }) => {
    return (React.createElement(StyledLogoWrapper, null,
        React.createElement(StyledLogo, { butterfly: true, homeLink: homeLink, dataQa: "logoMobile", size: 28 }),
        React.createElement(StyledLogo, { variant: "duo", size: 96, homeLink: homeLink, dataQa: "logo" })));
};
export const HeaderLoggedIn = ({ className, helpLink, homeLink, }) => {
    return (React.createElement(StyledHeaderPlacebo, { className: className },
        React.createElement(StyledHeaderWrapper, null,
            React.createElement(StyledCenterContainer, null,
                React.createElement(Logo, { homeLink: homeLink }),
                React.createElement(LoggedInSubHeader, { helpLink: helpLink })))));
};
//# sourceMappingURL=HeaderLoggedIn.js.map